import {Component, OnInit} from '@angular/core';

@Component ({
    selector: 'app-blood-transfusion',
    templateUrl: './blood-transfusion.component.html',
    styleUrls: ['./blood-transfusion.component.css']
})
export class BloodTransfusionComponent implements OnInit {
    constructor() {
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/blood-transfusion/blood-transfusion.component.ts